import apiSlice from "./ApiSlice";

export const branchApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllBranches: builder.query({
      query: () => {
        return {
          url: "/branch",
          method: "GET",
        };
      },
    }),

    // GET
    getBranches: builder.query({
      providesTags: ["branches"],
      query: (body) => {
        return {
          url: "/branch",
          method: "POST",
          body,
        };
      },
    }),

    // Delete
    deleteBranch: builder.mutation({
      invalidatesTags: ["branches"],
      query: (id: string) => {
        return {
          url: `/branch/${id}`,
          method: 'DELETE',
        };
      },
    }),

    // ADD
    addBranch: builder.mutation({
      invalidatesTags: ["branches"],
      query: (body) => {
        return {
          url: "/branch/add",
          method: "POST",
          body,
        };
      },
    }),
    //Single View
    viewBranch: builder.query({
      providesTags: ["branches"],
      query: (id: any) => {
        return {
          url: `/branch/${id}`,
          method: "GET",
        };
      },
    }),
    //Edit
    editBranch: builder.mutation({
      invalidatesTags: ["branches"],
      query: ({ body, id }: any) => {
        return {
          url: `/branch/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllBranchesQuery,
  useGetBranchesQuery,
  useAddBranchMutation,
  useDeleteBranchMutation,
  useEditBranchMutation, useViewBranchQuery
} = branchApi;
